// client and server can read from this config file. not secure
export const PROXY_PATH = '/rental-manager/inbox/proxy';
export const BASE_API = 'rental-manager-api/api/v1';
export const BASE_PATH = '/rental-manager/inbox';

export default {
  BASE_API,
  BASE_PATH,
  PROXY_PATH,
};
